import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-id", "data-description", "data-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "TrackingEvent TrackingRetrigger",
    "data-action": "impr",
    "data-type": "study",
    "data-id": _ctx.id,
    "data-description": _ctx.title,
    "data-label": _ctx.dataLabel
  }, null, 8 /* PROPS */, _hoisted_1))
}